/**
 * @module app.swiper
 */
//

/**
 * No-brainer swipe implementation taken from unmaintained
 * https://github.com/marcandre/detect_swipe/blob/master/jquery.detect_swipe.js
 * Note that bootstrap4 directly supports swiping.
 * @param {Element} element The element to add swipping capabilities to.
 * @param {function(string)} onSwipe A callback called with the detected direction (left, right, up or down).
 * @param {number=} threshold An optional threshold value.
 * @param {boolean=} preventDefault Whether to prevent default touch events.
 * @return {function()} A function to call to release resources.
 */
const swiper = function(element, onSwipe, threshold = 20, preventDefault = true) {
  let startX;
  let startY;
  let isMoving = false;

  function onTouchEnd() {
    element.removeEventListener('touchmove', onTouchMove);
    element.removeEventListener('touchend', onTouchEnd);
    isMoving = false;
  }

  function onTouchMove(e) {
    if (preventDefault) {
      e.preventDefault();
    }
    if (isMoving) {
      const x = e.touches[0].pageX;
      const y = e.touches[0].pageY;
      const dx = startX - x;
      const dy = startY - y;
      let dir;
      const ratio = window.devicePixelRatio || 1;
      if (Math.abs(dx) * ratio >= threshold) {
        dir = dx > 0 ? 'left' : 'right';
      } else if (Math.abs(dy) * ratio >= threshold) {
        dir = dy > 0 ? 'up' : 'down';
      }
      if (dir) {
        onTouchEnd();
        onSwipe(dir);
      }
    }
  }

  function onTouchStart(e) {
    if (e.touches.length == 1) {
      startX = e.touches[0].pageX;
      startY = e.touches[0].pageY;
      isMoving = true;
      element.addEventListener('touchmove', onTouchMove, false);
      element.addEventListener('touchend', onTouchEnd, false);
    }
  }

  function destroy() {
    element.removeEventListener('touchstart', onTouchStart, false);
  }

  element.addEventListener('touchstart', onTouchStart, false);

  return destroy;
};


export default swiper;
